import { UPDATE_AI_CONFIG } from "redux/types";
import client from "graphql/client";
import { loader } from "graphql.macro";
const updateConfigAIMutation = loader("graphql/mutations/configAI/editConfigAI.graphql");

export const updateConfigAI = (configData) => {
    return async (dispatch) => {
        try {  
            const cleanedData = { ...configData };
            if (cleanedData.id === "") {
                delete cleanedData.id;
            }
            if (!cleanedData.lastUpdated) {
                delete cleanedData.lastUpdated;
            }

            if (!cleanedData.__typename) {
                delete cleanedData.__typename;
            }
            
            const { data } = await client.mutate({
                mutation: updateConfigAIMutation,
                variables: {
                    configAI: cleanedData,
                },
            });

            dispatch({
                type: UPDATE_AI_CONFIG,
                payload: data.editConfigAI,
            });


        } catch (error) {
            console.error("Failed to update AI config:", error);
        }
    };
};